export const MAX_FILE_SIZE_MB = {
  image: 250,
  video: 2048,
  audio: 250,
  application: 99999,
};

export type MaxSizeFileType = keyof typeof MAX_FILE_SIZE_MB;
